import { gql } from '@apollo/client'

export const CREATE_API_TOKEN = gql`
  mutation CREATE_API_TOKEN {
    apiTokenCreate {
      data {
        id
      }
    }
  }
`
